import React from 'react';
import {useTranslation} from "react-i18next";
import {useDish} from "../utils/contexts/dish-context";
import Dish from "../components/CalculateImpact/Dish/Dish";
import NutritionalForm from "../components/CalculateImpact/Dish/Nutritional/NutritionalForm";
import IngredientsWeightForm from "../components/CalculateImpact/Dish/IngredientsWeightForm";
import Button from "../components/UI/Button";
import {useNavigate} from "react-router-dom";
import TabelogInput from "../components/CalculateTabelog/TabelogInput";

const CalculateTabelog = () => {

    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const {dish, weightModalStatus, nutritionalModalStatus, setDish} = useDish();
    const isJapanese = i18n.language === 'ja';

    React.useEffect(() => {
        if (!isJapanese) {
            navigate('/impact/calculate');
        }
    }, [isJapanese, navigate]);

    if (!isJapanese) return null;

    const handleImpact = () => {
        setDish(undefined);
        navigate('/impact/calculate');
    }

    const handleGdo = () => {
        setDish(undefined);
        navigate('/gdo');
    }

    return (
        <div>
            <div className="p-2 bg-blue-100 relative">
                <div className="absolute top-0 right-0 flex gap-2 items-center justify-center px-2 py-3.5">
                    <Button onClick={handleImpact}>IMPACT</Button>
                    <Button onClick={handleGdo}>GDO</Button>
                </div>
                <div className="text-lg font-bold uppercase">{t('tabelog.title', 'Calculate Tabelog')}</div>
                <TabelogInput/>
            </div>
            {dish && <Dish/>}
            {dish && weightModalStatus &&
                <IngredientsWeightForm/>
            }
            {dish && nutritionalModalStatus &&
                <NutritionalForm/>
            }
        </div>
    );
};

export default CalculateTabelog;
